import React from 'react'
import content from '../data/contentData.json'

export default function Footer(){
  return (
    <footer className=" relative bg-gray-50 mt-12 py-6">
      <div className="container text-sm text-gray-600">
        <div dangerouslySetInnerHTML={{__html: content.contacts.text}} />
        <div className="mt-2">Контакты: <a href="tel:+79163328259" className="text-blue-600 hover:underline">8-916-332-82-59</a> • <a href="mailto:laptshka@mail.ru" className="text-blue-600 hover:underline">laptshka@mail.ru</a></div>
        <div className="mt-2">© {new Date().getFullYear()} Лапшина Ирина</div>
      </div>
    </footer>
  )
}
